import { handleErrors } from "@/utils/handle-errors";
import fetch from "@mv/flow-shared-utils/functions/fetch";
import { SdkExceptLandingPage } from "@/interfaces/sdk-dictionary";
export const loadTables = (nameVersion: string, numberVersion: string) => ({ type: "loadTables", nameVersion, numberVersion });
export const loadTablesIndex = (nameVersion: string, numberVersion: string) => ({ type: "loadTablesIndex", nameVersion, numberVersion });
export const loadTablesByProduct = (product: string, page: number, nameVersion: string, numberVersion: string) => ({
  type: "loadTablesByProduct",
  product,
  page,
  nameVersion,
  numberVersion,
});
export const loadTable = (id: string) => ({ type: "loadTable", id });
export const loadTableProductFilter = (id: string, nameVersion: string, numberVersion: string) => ({
  type: "loadTableProductFilter",
  id,
  nameVersion,
  numberVersion,
});
export const loadConstraints = (owner: string, table: string, column: string, nameVersion: string, numberVersion: string) => ({
  type: "loadConstraints",
  owner,
  table,
  column,
  nameVersion,
  numberVersion,
});
export const searchTablesByProduct = (product: string, search: string, page: number, nameVersion: string, numberVersion: string) => ({
  type: "searchTablesByProduct",
  product,
  search,
  page,
  nameVersion,
  numberVersion,
});
export const findByUserAndEnvironmentAndPermission = (environmentId: number) => ({ type: "findByUserAndEnvironmentAndPermission", environmentId });
export const saveCheckLandingPageDictionary = (exceptLandingPage: SdkExceptLandingPage) => ({
  type: "saveCheckLandingPageDictionary",
  exceptLandingPage,
});

export const actions = {
  findByUserAndEnvironmentAndPermission(state: any, { environmentId }: { environmentId: number }) {
    return fetch(`core/api/permission/environment/${environmentId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  saveCheckLandingPageDictionary(state: any, { exceptLandingPage }: { exceptLandingPage: SdkExceptLandingPage }) {
    return fetch(`core/api/exceptlandingpage`, {
      method: "POST",
      body: JSON.stringify(exceptLandingPage),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  loadTables(state: any, { nameVersion, numberVersion }: { nameVersion: string; numberVersion: string }) {
    return fetch(`dictionary/api/table/version/${nameVersion}/${numberVersion}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadTablesIndex(state: any, { nameVersion, numberVersion }: { nameVersion: string; numberVersion: string }) {
    return fetch(`dictionary/api/table/product/version/${nameVersion}/${numberVersion}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadTablesByProduct(
    state: any,
    { product, page, nameVersion, numberVersion }: { product: string; page: number; nameVersion: string; numberVersion: string }
  ) {
    // tslint:disable-next-line:max-line-length
    return fetch(`dictionary/api/table/product/id/${product}/version/${nameVersion}/${numberVersion}?firstResult=${page - 1}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadConstraints(
    state: any,
    { owner, table, column, nameVersion, numberVersion }: { owner: string; table: string; column: string; nameVersion: string; numberVersion: string }
  ) {
    // tslint:disable-next-line:max-line-length
    return fetch(`dictionary/api/constraint/table/${owner}/${table}/column/${column}/version/${nameVersion}/${numberVersion}`)
      .then(handleErrors)
      .then((data) => data);
  },

  searchTablesByProduct(
    state: any,
    {
      product,
      search,
      page,
      nameVersion,
      numberVersion,
    }: { product: string; search: string; page: number; nameVersion: string; numberVersion: string }
  ) {
    // tslint:disable-next-line:max-line-length
    return fetch(`dictionary/api/table/name/${search}/product/id/${product}/version/${nameVersion}/${numberVersion}?firstResult=${page - 1}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadTable(state: any, { id }: { id: string }) {
    return fetch(`dictionary/api/table/id/${id}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadTableProductFilter(state: any, { id, nameVersion, numberVersion }: { id: string; nameVersion: string; numberVersion: string }) {
    return fetch(`dictionary/api/table/product/filter/${id}/version/${nameVersion}/${numberVersion}`)
      .then(handleErrors)
      .then((data) => data);
  },
};
